export const HOUSE = {
  // nav
  navLogo: 'nav-logo',
  navDiscover: 'nav-discover',
  navEnvironments: 'nav-environments',
  navFounder: 'nav-founder',
  navInquiryCta: 'nav-inquiry-cta',
  // hero
  heroHeading: 'hero-heading',
  heroPrimaryCta: 'hero-primary-cta',
  heroSecondaryCta: 'hero-secondary-cta',
  // sections
  sectionProblem: 'section-problem',
  sectionSolution: 'section-solution',
  sectionEnvironments: 'section-environments',
  sectionExperience: 'section-experience',
  sectionVision: 'section-vision',
  sectionFounder: 'section-founder',
  sectionInquiry: 'section-inquiry',
  // inquiry form
  inquiryFirstName: 'inquiry-first-name',
  inquiryLastName: 'inquiry-last-name',
  inquiryEmail: 'inquiry-email',
  inquiryOrganization: 'inquiry-organization',
  inquiryRole: 'inquiry-role',
  inquiryType: 'inquiry-type',
  inquiryMessage: 'inquiry-message',
  inquirySubmit: 'inquiry-submit',
  inquirySuccess: 'inquiry-success-message',
  inquiryError: 'inquiry-error-message',
};
